import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import { Upload } from "antd";
import { bindActionCreators } from "redux";
import { importPlanogramData } from "../../../../api/menu/master-files/planogram-maintenance/actions";

class ImportPlanogramModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            uploadedXlsx: [],
            uploadedXlsxName: "",
            autoPopulate: false
        };

        this.inputRef = createRef();

        this.handleImportFile = this.handleImportFile.bind(this);
    }

    handleImportFile = ({ fileList }) => {
        const file = fileList[(fileList || []).length - 1];
        const newFilesList = [file];

        this.setState({
            uploadedXlsx: newFilesList,
            uploadedXlsxName: newFilesList.length ? newFilesList[0].name : ""
        });
    };

    handleSave = () => {
        const { uploadedXlsx, autoPopulate } = this.state;

        if (!Array.isArray(uploadedXlsx) || uploadedXlsx.length === 0) {
            return;
        }

        this.props.importPlanogramData(this.props.planogramId, autoPopulate,
            uploadedXlsx[0].originFileObj, this.props.onCancel);
    };

    render() {
        return (
            <div className="clearfix position-relative">
                <div className="form-group">
                    <div className="d-flex justify-content-between">
                        <label htmlFor="edit-planogram">
                            {`${this.state.uploadedXlsxName || "Select Excel File"}`}
                        </label>

                        <div className="custom-control custom-checkbox mb-2">
                            <input
                                id="edit-auto-populate"
                                type="checkbox"
                                checked={this.state.autoPopulate}
                                className="custom-control-input"
                                onChange={() => this.setState({
                                    autoPopulate: !this.state.autoPopulate
                                })}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="edit-auto-populate"
                            >
                                AutoPopulate
                            </label>
                        </div>
                    </div>
                    {/* <input */}
                    {/*     ref={this.inputRef} */}
                    {/*     type="file" */}
                    {/*     onChange={handleImportFile} */}
                    {/* /> */}
                    <Upload
                        listType="text"
                        onChange={this.handleImportFile}
                        fileList={this.state.uploadedXlsx}
                        name="planogram"
                        beforeUpload={() => false}
                        showUploadList={false}
                        multiple={false}
                        accept=".xlsx"
                    >
                        <Button variant="info">
                            Click to Upload Excel file
                        </Button>
                    </Upload>
                </div>
                <hr />
                <div className="text-right">
                    <button
                        className="btn btn-success ml-2"
                        onClick={this.handleSave}
                    >
                        Save
                    </button>
                    <button
                        className="btn btn-default ml-2"
                        onClick={this.props.onCancel}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.planogramMaintenance.loading,
});

const mapStateToDispatch = dispatch => ({
    importPlanogramData: bindActionCreators(importPlanogramData, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ImportPlanogramModal);
